import React from 'react';
import { Box } from '@chakra-ui/react';
import { Group, Link, Text } from '@melio/penny';

import { LabelCopy } from '@/cl/components/LabelCopy/LabelCopy.component';
import { useCopyEmailAnalytics } from '@/hooks/analytics/copyEmailAnalytics';
import { usePartnerConfig } from '@/hooks/partners';
import { usePlatformIntl } from '@/translations/Intl';
import { SectionHeaderWithButton } from '@/widgets/settings-page/Common/SectionHeaderWithButton.widget';

export type BillsInboxSettingsDetails = {
  billsInboxEmail: string;
};

export const BillsInboxSettingsSection = ({ billsInboxEmail }: BillsInboxSettingsDetails) => {
  const { formatMessage } = usePlatformIntl();
  const {
    partnerConfig: { billsInbox },
  } = usePartnerConfig();
  const { trackCopyEmailCopy, trackCopyEmailLink } = useCopyEmailAnalytics('SettingsCompany');
  const title = formatMessage('widgets.companySettings.billsInboxSection.title');
  const content = formatMessage('widgets.companySettings.billsInboxSection.content', {
    link: billsInbox?.learnMoreLink && (
      <Link
        variant="inline"
        href={billsInbox?.learnMoreLink}
        label={formatMessage('widgets.companySettings.billsInboxSection.linkText')}
        newTab
      />
    ),
  });
  const badge = formatMessage('widgets.companySettings.billsInboxSection.badge');
  return (
    <Group variant="vertical" width="full">
      <SectionHeaderWithButton title={title} badgeText={badge} />
      <Box>
        <Box marginBottom={6}>
          <Text>{content}</Text>
        </Box>
        <LabelCopy
          testId="bills-inbox-email-link"
          variant="button"
          label={billsInboxEmail}
          link={`mailto:${billsInboxEmail}`}
          buttonLabel={formatMessage('widgets.billsInbox.copyButtonLabel')}
          successMessage={formatMessage('widgets.billsInbox.successCopyToast')}
          errorMessage={formatMessage('widgets.billsInbox.errorCopyToast')}
          onCopy={trackCopyEmailCopy}
          onLinkClick={trackCopyEmailLink}
        />
      </Box>
    </Group>
  );
};
